import { Component, OnInit } from '@angular/core';
import { Faq } from 'src/app/models/faq';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  public faqs:Faq[];
  public currentFaq:number = 1;
  public image:string='/assets/imgs/faq-header.jpg';
  public title:string='Frequently Asked Questions';
  public blurb:string='Stuck? Need a bit of help, or a point in the right direction? You\'re in the right place!';
  public breadcrumbLinks=[];
  public thisPage:string='FAQs';

  constructor() {
    this.faqs=[{
      id: 1,
      question: 'What is Central CPD On-Demand?',
      answer: '<ul class="blue"><li><p>Central CPD On-Demand is an innovative online CPD solution for the whole practice team. Sign up for over 2,000 high-quality CPD videos, including short how-to videos, practical surgical tutorials, academy programmes and longer in-depth learning series – all available to watch anywhere and at any time.</p></li><li><p>CPD credit is awarded to the nearest 0.1 hour and is added to your personal CPD record once you have completed the relevant quiz for that video or resource. Lecture notes are also included for you to download and keep.</p></li><li><p>You can watch as much as you want, whenever you want – there are no time limits on any of our resources. There\'s always something new to discover, and videos and resources are added regularly.</p></li></ul>'
    },
    {
      id: 2,
      question: 'How much does Central CPD On-Demand cost?',
      answer: '<ul class="blue"><li><p>We offer a range of purchasing options to suit different needs. Choose from our commitment-free pay as you go account or set up an individual or practice subscription for unlimited access to the whole site.<ul><li><p>Pay as you go starts from as little as £35+VAT for 5 hours of certified CPD.</p></li><li><p>Individual subscriptions are £65+VAT per month or £595+VAT per year.</p></li><li><p>Practice subscriptions are £2,750+VAT per year for a team of up to 20 staff. This can work out as little as £137.50 per person for the whole year. Additional staff can be added for £137.50+VAT per user.</p></li></ul></p></li><li><p>We also offer a membership package for vets, nurses and practices, which combines our On-Demand subscription with free and discounted attendance courses at our central London venues. For more information please visit <a href="https://www.centralcpd.co.uk/membership" target="_blank">www.centralcpd.co.uk/membership</a></p></li></ul>'
    },
    {
      id: 3,
      question: 'Payment Options:',
      answer: '<ul class="blue"><li><p>Pay as you go and individual subscriptions can be purchased online. If you opt for a subscription, it will be set up on a rolling basis which you can cancel at any time. We will email you in advance of each payment due to be taken.</p></li><li><p>For annual practice subscriptions, practices can opt to pay by BACS by following the link on the pricing page to generate an invoice.</p></li><li><p>If you need to pay by BACS for any other type of subscription, please contact us at <a href="mailto:enquiries@centralcpd.co.uk">enquiries@centralcpd.co.uk</a> or use the <a href="/contact">Contact Us</a> form.</p></li></ul>'
    },
    {
      id: 4,
      question: 'Where can I watch?',
      answer: '<ul class="blue"><li><p>Watch anywhere, anytime, on any internet-connected device around the world.</p></li></ul>'
    },
    {
      id: 5,
      question: 'How do I cancel?',
      answer: '<ul class="blue"><li><p>All subscriptions are set up on a rolling subscription basis but are completely flexible and can be cancelled at any time via your account page. You can opt to:<ul><li><p>Suspend your subscription until you are ready to restart it - this works particularly well for those on a monthly subscription</p></li><li><p>Convert your account to a commitment free pay as you go account</p></li><li><p>Cancel your account all together. You will always be able to access your CPD record and reactivate any account type should you wish.</p></li></ul></p></li></ul>'
    },
    {
      id: 6,
      question: 'What can I watch on Central CPD On-Demand?',
      answer: '<ul class="blue"><li><p>We have a whole host of video resources for vets, vet nurses and other practice staff covering;<ul><li><p>Small animal, equine and exotics clinical subjects</p></li><li><p>Practice management and reception skills</p></li><li><p>Conference footage</p></li><li><p>Relevant non-clinical subjects</p></li></ul></p></li></ul>'
    },
    {
      id: 8,
      question: 'Are your On-Demand CPD videos updated regularly?',
      answer: '<ul class="blue"><li><p>Yes, all our CPD videos are regularly reviewed, edited, and updated to ensure they reflect the latest advancements. Any necessary updates or revisions are made promptly to ensure that you have access to the most up-to-date information.</p></li></ul>'
    }
    ];
  }

  public setCurrentFaq(id:number){
    this.currentFaq=id;
  }

  ngOnInit() {
  }

}
